<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item url="/dashboard-default" :class="getRoute() == 'dashboard-default' ? 'active' : ''"
          navText="Métricas" v-if="user?.role == '1' || user?.role == '2'">
          <template v-slot:icon>
            <i class="fas fa-home text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role == '3'">
        <sidenav-item url="/operador/dashboard" :class="getRoute() == 'operador/dashboard' ? 'active' : ''"
          navText="Métricas">
          <template v-slot:icon>
            <i class="fas fa-home text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role == '1' || user?.role == '2'">
        <sidenav-item url="/pos" :class="getRoute() == 'pos' ? 'active' : ''" navText="POS">
          <template v-slot:icon>
            <i class="fas fa-cash-register text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role == '3'">
        <sidenav-item url="/operador/pos" :class="getRoute() == 'operador/pos' ? 'active' : ''" navText="POS">
          <template v-slot:icon>
            <i class="fas fa-cash-register text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('usuarios')">
        <sidenav-item url="/users" :class="getRoute() == 'users' ? 'active' : ''" navText="Usuarios">
          <template v-slot:icon>
            <i class="fas fa-users text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role == '3'">
        <sidenav-item url="/operador/ventas" :class="getRoute() == 'operador/ventas' ? 'active' : ''"
          navText="Ventas / Ingresos">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('insumos')">
        <sidenav-item url="/inventory" :class="getRoute() == 'inventory' ? 'active' : ''" navText="Inventario">
          <template v-slot:icon>
            <i class="fas fa-box text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('compras')">
        <sidenav-item url="/purchases" :class="getRoute() == 'purchases' ? 'active' : ''" navText="Compras / Salidas">
          <template v-slot:icon>
            <i class="fas fa-shopping-cart text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('remisiones')">
        <sidenav-item url="/remissions" :class="getRoute() == 'remissions' ? 'active' : ''" navText="Ventas / Ingresos">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role == '1' || user?.role == '2'">
        <sidenav-item url="/settings" :class="getRoute() == 'settings' ? 'active' : ''" navText="Configuración">
          <template v-slot:icon>
            <i class="fas fa-cog text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="false">
        <sidenav-item url="/reports" :class="getRoute() == 'reports' ? 'active' : ''" navText="Informes">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>


    </ul>
  </div>
  <div class="mx-3 sidenav-footer text-center mt-3">


  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";


export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
      dropDownStatus: true,
      user: {}
    };
  },
  components: {
    SidenavItem,
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem('user'));
    console.log(user);
    if (user) {
      this.user = user;
    }
  },
  methods: {
    /** Si el usuario es supervisor (role 2), solo muestra el ítem si tiene el módulo activo en supervisor_modules. Si es admin (role 1) u otro, muestra según la regla original. */
    showModule(moduleKey) {
      if (!this.user) return false;
      const role = this.user.role;
      // Administrador: ve todo (usuarios, modelo, produccion, operaciones, inventario, insumos, compras, remisiones, nomina)
      if (role === '1' || role === 1) return true;
      // Supervisor: solo si tiene el módulo en supervisor_modules
      if (role === '2' || role === 2) {
        const mods = Array.isArray(this.user.supervisor_modules)
          ? this.user.supervisor_modules
          : (typeof this.user.supervisor_modules === 'string' ? (this.user.supervisor_modules ? JSON.parse(this.user.supervisor_modules) : []) : []);
        return mods && mods.includes(moduleKey);
      }
      return false;
    },
    getRoute() {
      const path = this.$route.path;
      // Si la ruta es de operador, devolver la ruta completa sin la barra inicial
      if (path.startsWith('/operador/')) {
        return path.substring(1); // Remover la barra inicial: '/operador/dashboard' -> 'operador/dashboard'
      }
      // Para otras rutas, devolver solo la primera parte
      const routeArr = path.split("/");
      return routeArr[1] || '';
    },
    useDropDown() {
      this.dropDownStatus = !this.dropDownStatus;
    },

  },
};
</script>
